import { render, staticRenderFns } from "./CanvasSectionRow.vue?vue&type=template&id=596b6a1b&"
import script from "./CanvasSectionRow.vue?vue&type=script&lang=js&"
export * from "./CanvasSectionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports